import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const systemLinks = [
    { name: "電商 WMS", href: "/wms/ecommerce" },
    { name: "3PL WMS", href: "/wms/3pl" },
    { name: "TMS 系統", href: "/tms" },
    { name: "ERP 系統", href: "/erp" },
  ];

  const guideLinks = [
    { name: "香港 WMS 指南", href: "/hong-kong-wms-system" },
    { name: "WMS / TMS 選型指南", href: "/wms-tms-selection-guide" },
    { name: "知識庫", href: "/knowledge" },
    { name: "新聞解讀", href: "/insights" },
  ];

  const companyLinks = [
    { name: "首頁", href: "/" },
    { name: "關於我們", href: "/about" },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2 xl:col-span-2">
            <div className="flex items-center space-x-2 mb-6">
              <img
                src="https://static.readdy.ai/image/d8e2421d44e5bedaac00a22953471cdd/4d5b28f5624aa1fbcf1be13b1e18eefe.png"
                alt="AUTOCHAIN TECHNOLOGY LIMITED"
                className="h-10 object-contain"
              />
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed">
              專業的智慧物流解決方案專家，提供 WMS 倉庫管理系統和 TMS
              送貨管理系統， 助力企業實現數位化轉型，提升營運效率。
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-blue-400"></i>
                <span className="text-gray-300">+852 9425 2903</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-blue-400"></i>
                <span className="text-gray-300">sales@autochain.com.hk</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-map-pin-line text-blue-400"></i>
                <span className="text-gray-300">
                  觀塘興業街4號The Wave 七樓
                </span>
              </div>
            </div>
          </div>

          {/* System Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">系統方案</h3>
            <ul className="space-y-2">
              {systemLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Guide Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">攻略教學</h3>
            <ul className="space-y-2">
              {guideLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">公司資訊</h3>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact CTA */}
          <div>
            <h3 className="text-lg font-semibold mb-4">聯絡我們</h3>
            <p className="text-gray-300 mb-4">
              立即聯絡我們，定制您的物流解決方案
            </p>
            <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap">
              免費諮詢
            </button>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} AUTOCHAIN TECHNOLOGY LIMITED. 版權所有。
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy"
                className="text-gray-400 hover:text-gray-300 text-sm cursor-pointer"
              >
                隱私政策
              </Link>
              <Link
                to="#"
                className="text-gray-400 hover:text-gray-300 text-sm cursor-pointer"
              >
                服務條款
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
